import { Link } from 'react-router-dom';
import { Home } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from '../components/ui/button';

export default function NotFound() {
  const { language } = useLanguage();

  return (
    <div className="min-h-[70vh] flex flex-col items-center justify-center px-4">
      <h1 className="text-6xl lg:text-8xl font-outfit font-black text-cyan-400 mb-4">
        404
      </h1>
      <p className="text-xl text-slate-400 mb-8 text-center">
        {language === 'pt' 
          ? 'Página não encontrada' 
          : 'Page not found'}
      </p>
      <Link to={`/${language}`}>
        <Button className="bg-cyan-500 text-slate-950 hover:bg-cyan-400 font-bold rounded-full px-8">
          <Home className="w-4 h-4 mr-2" />
          {language === 'pt' ? 'Voltar ao início' : 'Back to home'}
        </Button>
      </Link>
    </div>
  );
}
